webpackJsonp([45],{

/***/ "8asQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j65F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/screenLoading.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var screenLoading = ({
  name: 'screenLoading',
  data: function data() {
    return {
      routeType: true
    };
  },

  inject: ['reload'],
  //挂载
  created: function created() {
    var width = document.documentElement.clientWidth;
    var lang = localStorage.getItem('language') || "";
    // var lang = (navigator.systemLanguage ? navigator.systemLanguage : navigator.language);
    //获取浏览器配置语言 #括号内是个运算，运算过后赋值给lang，当?前的内容为true时把?后的值赋给lang，为False时把:后的值赋给lang
    // var lang = lang.substr(0, 2);//获取lang字符串的前两位
    var url = '';
    if (width > 1024) {
      this.routeType = true;
      url = '';
    } else {
      this.routeType = false;
      url = '/wap';
    }
    if (lang && lang == 'zh') {
      this.$router.push({
        path: url + '/zh/index'
      });
    } else if (lang && lang == 'en') {
      this.$router.push({
        path: url + '/en/index'
      });
    } else {
      if (width < 1024) {
        this.$router.push({
          path: '/wap/screenLoading'
        });
      }
    }
  },

  methods: {
    // handleSelectLang (lang) {
    //   let width = document.documentElement.clientWidth; //clientWidth网页可见区域的高度
    //   if (width > 1024) {
    //     console.log('我是PC')
    //     this.$router.push({ path: '/' + lang + '/index' })
    //   } else {
    //     console.log('我是移动')
    //     this.$router.push({ path: '/wap/' + lang + '/index' })
    //   }
    //   // this.$router.go(0)
    //   // this.reload()
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-70b52662","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/screenLoading.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screenLoading"},[_c('div',{staticClass:"lang_select",class:_vm.routeType? '':'iphoneStyle'},[_c('router-link',{staticClass:"lang_zh",attrs:{"to":{ path: '/zh/index' }}},[_c('div',{staticClass:"zh_first"},[_vm._v("中文")]),_vm._v(" "),_c('div',{staticClass:"zh_content"},[_c('div',{staticClass:"item"},[_vm._v("为不可预测的未来")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v("培养具有国际思维的时代精英")])])]),_vm._v(" "),_c('router-link',{staticClass:"lang_en",attrs:{"to":{ path: '/en/index' }}},[_c('div',{staticClass:"en_first"},[_vm._v("ENGLISH")]),_vm._v(" "),_c('div',{staticClass:"en_content"},[_vm._v("Cultivate Elites With An International Vision To Rise Above Whatever Tomorrow Brings")])])],1),_vm._v(" "),_c('div',{staticClass:"intro"},[_vm._v("金成教育集团 Jincheng Education Group")]),_vm._v(" "),_c('a',{staticClass:"jump",attrs:{"href":"/wap/screenLoading"}},[_vm._v("跳转到移动")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_screenLoading = (esExports);
// CONCATENATED MODULE: ./src/components/layout/screenLoading.vue
function injectStyle (ssrContext) {
  __webpack_require__("8asQ")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70b52662"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  screenLoading,
  layout_screenLoading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_layout_screenLoading = __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/45.2d981b6bc8090569fedf.js